var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100 flex flex-col flex-grow",attrs:{"id":"outer"}},[_c('AppHeader',{staticClass:"flex"}),_c('main',{staticClass:"flex flex-1"},[_vm._t("default")],2),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }